module.exports = __webpack_public_path__ + "img/arrow-right2.888db0eb.svg";